<template>
  <div class="tap">
    <div class="address-input">
      <input
        type="text"
        maxlength="50"
        placeholder="이름/휴대전화번호/주소 검색"
        v-on:input="query = $event.target.value"
        v-on:keyup.enter="search()"
        v-model="query"
        v-focus
      />
      <img
        v-if="searchStatus === 'init'"
        class="address-input__img"
        src="@/assets/img/ic_cancle_circle_input.svg"
        @click="(query = ''), search()"
      />
      <img
        v-else
        class="address-input__img"
        src="@/assets/img/ic_search.svg"
        @click="search"
      />
    </div>
    <div
      class="pin-tooltip"
      v-if="addressList.length > 0 && searchStatus === 'none'"
    >
      <div class="pin-tooltip__content">
        <img src="@/assets/img/order/bookmark_on.svg" />
        <div>
          핀 아이콘 선택시 해당 주소지 정보가 즐겨찾기에 추가/삭제됩니다
        </div>
      </div>
    </div>
    <div class="address-result">
      <div v-if="searchStatus === 'init' && searchAddressList.length > 0">
        <address-result-List
          v-for="(list, idx) in searchAddressList"
          :address="list"
          :key="idx"
          @deleteAddress="$emit('deleteAddress', list)"
          @addBookmark="$emit('addBookmark', list)"
          @select="$emit('select', list)"
        ></address-result-List>
      </div>
      <div class="address-result__empty" v-else-if="searchStatus === 'loading'">
        <i class="fas fa-circle-notch fa-spin"></i>
        <div>검색 중 입니다.</div>
      </div>
      <div
        class="address-result__empty"
        v-else-if="searchStatus === 'init' && searchAddressList.length === 0"
      >
        <img src="@/assets/img/ic_search_empty.svg" />
        <div>검색 결과가 없습니다.</div>
      </div>
      <div v-else>
        <address-result-List
          v-for="(list, idx) in addressList"
          :address="list"
          :key="idx"
          @deleteAddress="$emit('deleteAddress', list)"
          @addBookmark="$emit('addBookmark', list)"
          @select="$emit('select', list)"
        ></address-result-List>
      </div>
    </div>
  </div>
</template>
<script>
import AddressResultList from "../AddressResultList.vue";
import searchResultList from "../searchResultList.vue";
export default {
  data() {
    return {
      query: "",
    };
  },
  components: { AddressResultList, searchResultList },
  props: ["code", "addressList", "searchAddressList", "searchStatus"],
  created() {},
  methods: {
    search() {
      this.$emit("searchRecentAddress", this.query);
    },
  },
};
</script>
<style src="../layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
<style scoped>
.tap {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
